module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('Home')
      }
    }
  }, [_c('img', {
    staticClass: "logo-title-area",
    attrs: {
      "src": require("../assets/icon/logo.png"),
      "alt": "L"
    }
  })]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchBar),
      expression: "showSearchBar"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    attrs: {
      "inline": false,
      "autocomplete": "on"
    }
  }, [_c('el-form-item', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeyword),
      expression: "searchKeyword"
    }],
    staticClass: "input-info",
    attrs: {
      "type": "search",
      "name": "search",
      "autocomplete": "on",
      "placeholder": "主題、關鍵字、編號搜尋"
    },
    domProps: {
      "value": (_vm.searchKeyword)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": require("../assets/icon/ic_search.png"),
      "alt": "Submit"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  })])], 1)], 1), _vm._v(" "), (_vm.showCourseSearchBar) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    attrs: {
      "inline": false,
      "autocomplete": "on"
    }
  }, [_c('el-form-item', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.courseKeyword),
      expression: "courseKeyword"
    }],
    staticClass: "input-info",
    attrs: {
      "type": "search",
      "name": "search",
      "autocomplete": "on",
      "placeholder": "主題、關鍵字、編號搜尋"
    },
    domProps: {
      "value": (_vm.courseKeyword)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.courseKeyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.courseKeyword.trim().length > 0),
      expression: "courseKeyword.trim().length > 0"
    }],
    staticClass: "clear-icon",
    attrs: {
      "src": require("../assets/icon/ic_clear.png"),
      "alt": "C"
    },
    on: {
      "click": _vm.clearCourseKeyword
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": require("../assets/icon/ic_search.png"),
      "alt": "Submit"
    },
    on: {
      "click": function($event) {
        return _vm.courseSearch()
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.nowStatus === 7) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    attrs: {
      "inline": false,
      "autocomplete": "on"
    }
  }, [_c('el-form-item', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.accountList.keyword),
      expression: "$store.state.accountList.keyword"
    }],
    staticClass: "input-info",
    attrs: {
      "type": "search",
      "name": "searchAccount",
      "autocomplete": "on",
      "placeholder": "搜尋會員帳號或姓名"
    },
    domProps: {
      "value": (_vm.$store.state.accountList.keyword)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.prevent($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.accountList, "keyword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.accountList.keyword.trim().length > 0),
      expression: "$store.state.accountList.keyword.trim().length > 0"
    }],
    staticClass: "clear-icon",
    attrs: {
      "src": require("../assets/icon/ic_clear.png"),
      "alt": "C"
    },
    on: {
      "click": function($event) {
        return _vm.clearAccountSearch()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "input-icon",
    attrs: {
      "src": require("../assets/icon/ic_search.png"),
      "alt": "Submit"
    },
    on: {
      "click": function($event) {
        return _vm.searchAccount()
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 8
    }
  }, [(this.externalLinkList.length > 0) ? _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "userinfo-inner"
  }, [_vm._v("\n\t\t\t\t\t友站連結\n\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "menu-area",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.externalLinkList), function(obj) {
    return _c('div', {
      key: obj.id
    }, [_c('el-dropdown-item', {
      staticStyle: {
        "text-align": "center",
        "color": "#626874"
      }
    }, [_c('a', {
      staticClass: "el-dropdown-item",
      attrs: {
        "target": "_blank",
        "href": obj.link
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(obj.title) + "\n\t\t\t\t\t\t\t")])])], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "userinfo-inner",
    on: {
      "click": function($event) {
        return _vm.homeHub('Course')
      }
    }
  }, [_vm._v(" 我的課程 ")]), _vm._v(" "), _c('span', {
    staticClass: "userinfo-inner",
    on: {
      "click": function($event) {
        return _vm.homeHub('Favorite')
      }
    }
  }, [_vm._v(" 我的最愛 ")]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('el-badge', {
    attrs: {
      "is-dot": _vm.$store.state.regDot
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon/ic_user.png")
    }
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "menu-area",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(this.$store.state.isBackendMode) ? _c('div', [(this.$store.state.isSystemAdminMode) ? _c('div', [_c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('Department')
      }
    }
  }, [_vm._v("部門管理\n\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('AccountList')
      }
    }
  }, [_vm._v("帳號管理\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', [_c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('RegApproval')
      }
    }
  }, [(_vm.$store.state.regDot) ? _c('div', [_c('span', {
    staticStyle: {
      "padding-left": "13px"
    }
  }, [_vm._v("註冊審查")]), _vm._v(" "), _c('el-badge', {
    staticStyle: {
      "right": "5px"
    },
    attrs: {
      "is-dot": ""
    }
  })], 1) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t註冊審查\n\t\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('Report')
      }
    }
  }, [_vm._v("統計報表\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('Category')
      }
    }
  }, [_vm._v("主題分類\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('Profile')
      }
    }
  }, [_vm._v("個人資訊\n\t\t\t\t\t")]), _vm._v(" "), _c('div', [_c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.homeHub('Setting')
      }
    }
  }, [_vm._v("其他設定\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    staticStyle: {
      "text-align": "center",
      "color": "#626874"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("登出\n\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showCategoryBar) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticClass: "menu-bar unselectable categoryGroup-bar"
  }, _vm._l((_vm.categoryOrder), function(categoryGroup, index) {
    return _c('div', {
      key: categoryGroup.id,
      staticClass: "menu-item categoryGroup-item",
      class: categoryGroup.id === _vm.activeCategoryGroup ? 'categoryGroup-active' : '',
      on: {
        "click": function($event) {
          return _vm.selectCategoryGroup(categoryGroup.id, index)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(categoryGroup.name) + "\n\t\t\t"), _c('div', {
      staticClass: "triangle"
    })])
  }), 0), _vm._v(" "), (_vm.activeCategoryGroup) ? _c('el-row', {
    staticClass: "menu-bar unselectable category-bar"
  }, _vm._l((_vm.categoryList), function(category) {
    return _c('div', {
      key: category.id,
      staticClass: "menu-item category-item",
      class: category.id === _vm.activeCategory ? 'category-active' : '',
      on: {
        "click": function($event) {
          return _vm.selectCategory(category.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(category.title) + "\n\t\t\t")])
  }), 0) : _vm._e()], 1) : (this.$store.state.nowStatus === 1) ? _c('el-col', {
    staticClass: "vice-bar",
    attrs: {
      "span": 24
    }
  }, [(this.$store.state.isSystemAdminMode ||
    (this.$store.state.isBackendMode && this.$store.state.infoActualDepId && (this.$store.state.infoActualDepId === this.$store.state.userActualDepId))) ? _c('div', [_c('el-button', {
    staticClass: "edit-btn",
    on: {
      "click": _vm.editFile
    }
  }, [_vm._v("編輯\n\t\t\t\t"), _c('img', {
    staticClass: "edit-icon",
    attrs: {
      "src": require("../assets/icon/ic_edit_white.png"),
      "alt": "E"
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "delete-btn",
    on: {
      "click": _vm.deleteFile
    }
  }, [_vm._v("刪除\n\t\t\t\t"), _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": require("../assets/icon/ic_delete_blue.png"),
      "alt": "D"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-title",
    on: {
      "click": function($event) {
        return _vm.goPath(0, 'pre')
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.backText) + "\n\t\t\t"), _c('div', {
    staticClass: "back-icon"
  }, [_vm._v(_vm._s(_vm.backIcon))])]), _vm._v(" "), _c('div', {
    class: this.$store.state.isSystemAdminMode ||
      (this.$store.state.isBackendMode && this.$store.state.infoActualDepId && (this.$store.state.infoActualDepId === this.$store.state.userActualDepId)) ?
      'admin-tab-title' : 'tab-title'
  }, [(!this.$store.state.resourceList.author && _vm.$store.state.editResourceBreadcrumbs.length > 1) ? _c('div', {
    staticStyle: {
      "margin": "0px auto",
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticClass: "path-title",
    on: {
      "click": function($event) {
        return _vm.goPath(_vm.$store.state.editResourceBreadcrumbs[0].id, 'categoryGroup')
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.editResourceBreadcrumbs[0].name) + "\n\t\t\t\t\t"), _c('div', {
    staticClass: "path-icon"
  }, [_vm._v(_vm._s(_vm.pathIcon))])]), _vm._v(" "), _c('div', {
    staticClass: "path-title",
    on: {
      "click": function($event) {
        return _vm.goPath(_vm.$store.state.editResourceBreadcrumbs[1].id, 'category')
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.editResourceBreadcrumbs[1].name) + "\n\t\t\t\t\t"), _c('div', {
    staticClass: "path-icon"
  }, [_vm._v(_vm._s(_vm.pathIcon))])]), _vm._v(" "), _c('div', {
    staticClass: "path-title"
  }, [_vm._v(_vm._s(_vm.$store.state.editResourceBreadcrumbs[2]) + "\n\t\t\t\t")])]) : _vm._e()])]) : (this.$store.state.nowStatus === 2 && this.$store.state.isBackendMode) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "cancel-btn",
    attrs: {
      "disabled": this.$store.state.isCancelBtnDisabled
    },
    on: {
      "click": _vm.cancelFile
    }
  }, [_vm._v("取消\n\t\t")]), _vm._v(" "), _c('el-button', {
    staticClass: "save-btn",
    attrs: {
      "id": "save-file",
      "disabled": this.$store.state.isBtnProcessing
    },
    on: {
      "click": _vm.saveFile
    }
  }, [_vm._v("儲存\n\t\t")])], 1) : (this.$store.state.nowStatus === 10 && this.$store.state.isSystemAdminMode) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("部門管理")])]) : (this.$store.state.nowStatus === 3 && this.$store.state.isSystemAdminMode) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("主題分類")])]) : (this.$store.state.nowStatus === 5 || this.$store.state.nowStatus === 6) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "back-title",
    on: {
      "click": function($event) {
        return _vm.homeHub('Info')
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.backText) + "\n\t\t\t"), _c('div', {
    staticClass: "back-icon"
  }, [_vm._v(_vm._s(_vm.backIcon))])])]) : (this.$store.state.nowStatus === 7) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.accountPath[0]))])]) : (this.$store.state.nowStatus === 15) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("註冊審查")])]) : (this.$store.state.nowStatus === 13) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("統計報表")])]) : (this.$store.state.nowStatus === 8) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("個人資訊")])]) : (this.$store.state.nowStatus === 9 && this.$store.state.accountList.status === 2) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 42%",
      "position": "absolute"
    }
  }, [_c('el-button', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        return _vm.cancelAccount(true)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.saveAccount(true)
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    key: 0,
    staticClass: "path-title",
    on: {
      "click": function($event) {
        return _vm.returnAccount(0)
      }
    }
  }, [_vm._v("\n\t\t\t\t " + _vm._s(_vm.accountPath[0]) + "\n\t\t\t"), _c('div', {
    staticClass: "path-icon"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.pathIcon) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    key: 1,
    staticClass: "path-title",
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": function($event) {
        return _vm.returnAccount(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t " + _vm._s(_vm.accountPath[1]) + "\n\t\t")])]) : (this.$store.state.nowStatus === 9 && this.$store.state.accountList.status === 3) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 42%",
      "position": "absolute"
    }
  }, [_c('el-button', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        return _vm.cancelAccount(false)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.saveAccount(false)
      }
    }
  }, [_vm._v("儲存")])], 1), _vm._v(" "), _c('div', {
    key: 0,
    staticClass: "path-title",
    on: {
      "click": function($event) {
        return _vm.returnAccount(0)
      }
    }
  }, [_vm._v("\n\t\t\t\t " + _vm._s(_vm.accountPath[0]) + "\n\t\t\t"), _c('div', {
    staticClass: "path-icon"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.pathIcon) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    key: 1,
    staticClass: "path-title",
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": function($event) {
        return _vm.returnAccount(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t " + _vm._s(_vm.$store.state.editAccount.displayName) + "\n\t\t")])]) : (this.$store.state.nowStatus === 11) ? _c('el-col', {
    staticClass: "vice-bar",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("其他設定")])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    class: _vm.styleWithBar,
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper-info"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "collegeList": _vm.categoryGroupList,
      "categoryGroupList": _vm.categoryGroupList,
      "categories": _vm.categoriesForProps
    },
    on: {
      "setURL": _vm.setURL,
      "setAuthorList": _vm.setAuthorList,
      "getCategoriesGroup": _vm.getCategoriesGroup
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.home),
      expression: "hint.display && this.$store.state.hintStatus.home"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-776b5a22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 941
// module chunks = 170